import { BufferGeometry, ColorRepresentation, Mesh, MeshBasicMaterial } from 'three';
import { MeshBVHHelper } from 'three-mesh-bvh';

import { Collider } from '../../math/index.js';

export interface ColliderHelperOptions {
  displayEdges?: boolean;
  displayParents?: boolean;
  displayCollider?: boolean;
  depth?: number;
  opacity?: number;
  color?: ColorRepresentation;
  colliderColor?: ColorRepresentation;
  colliderOpacity?: number;
}

export class ColliderHelper extends MeshBVHHelper {
  colliderMesh: Mesh<BufferGeometry, MeshBasicMaterial>;

  constructor(collider: Collider, options?: ColliderHelperOptions) {
    const { depth, ...restOptions } = { ...options };

    const colliderMesh = new Mesh(
      collider.geometry,
      new MeshBasicMaterial({
        color: 0xff0086,
        wireframe: true,
        opacity: 0.3,
      })
    );

    (
      colliderMesh.geometry as BufferGeometry & {
        boundsTree: any;
      }
    ).boundsTree = collider.boundTree;

    super(colliderMesh, depth);
    this.colliderMesh = colliderMesh;
    this.add(colliderMesh);

    Object.entries(restOptions).forEach(([key, value]) => {
      // @ts-ignore
      this[key] = value;
    });
  }

  set displayCollider(v: boolean) {
    this.colliderMesh.visible = v;
  }

  get displayCollider() {
    return this.colliderMesh.visible;
  }

  // @ts-ignore
  set color(v: ColorRepresentation) {
    this.meshMaterial.color.set(v);
  }
  // @ts-ignore
  get color() {
    return this.meshMaterial.color;
  }

  set colliderColor(v: ColorRepresentation) {
    this.colliderMesh.material.color.set(v);
  }

  get colliderColor() {
    return this.colliderMesh.material.color;
  }

  set colliderOpacity(v: number) {
    this.colliderMesh.material.opacity = v;
  }

  get colliderOpacity() {
    return this.colliderMesh.material.opacity;
  }
}

export default ColliderHelper;
